<template>
  <div class="plan-wrap">
    <div class="seletc-list">
      <el-select
        class="multiple-select"
        filterable
        clearable
        v-model="filterData.promotionIds"
        :filter-method="filterPromotion"
        placeholder="选择广告组"
        @change="clickSearch()"
        multiple
        collapse-tags
      >
        <el-option v-for="item of promotionList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 12px"
        class="multiple-select"
        filterable
        clearable
        v-model="filterData.advertiserIds"
        placeholder="选择广告账户"
        @change="clickSearch()"
        multiple
        collapse-tags
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.advertiserName + ' (' + item.advertiserId + ')'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 12px"
        v-model="filterData.pkgs"
        multiple
        filterable
        class="multiple-select"
        collapse-tags
        placeholder="选择产品"
        @change="clickSearch()"
        clearable
      >
        <el-option
          v-for="item of appList"
          :key="item.package_name"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.package_name"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left: 12px"
        v-model="filterData.projectIds"
        multiple
        filterable
        :filter-method="filterAdSeries"
        class="multiple-select"
        collapse-tags
        placeholder="选择广告系列"
        @change="clickSearch()"
        clearable
      >
        <el-option
          v-for="item of adSeriesList"
          :key="item.campaignId"
          :label="item.campaignName"
          :value="item.campaignId"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 12px"
        multiple
        collapse-tags
        v-if="isAdmin"
        v-model="filterData.userIds"
        clearable
        placeholder="选择优化师"
        @change="clickSearch()"
      >
        <el-option v-for="item of optimizerList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        clearable
        style="width: 180px; margin-left: 12px"
        v-model="filterData.status"
        placeholder="选择广告组状态"
        @change="clickSearch()"
      >
        <el-option
          v-for="item of adSeriesStatusOptions.filter(
            (item) => !['UNSPECIFIED', 'UNKNOWN'].includes(item.value)
          )"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 12px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="clickSearch()"
      >
      </el-date-picker>
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-input
          placeholder="请输入广告组名称"
          prefix-icon="el-icon-search"
          v-model="filterData.search"
          class="search-input"
          style="width: 190px"
          @change="inputSearch"
        >
        </el-input>
        <div class="mult-wrap">
          <el-button class="top-btn" style="margin-right: 16px" @click="showPlBox = true">
            <svg-icon iconClass="pl" className="pl-icon"></svg-icon>批量操作</el-button
          >
          <span class="piliang border-bg" v-show="showPlBox">
            <span class="batch-span"
              >已选择<a>{{ checkedList.length }}</a
              >账户</span
            >
            <div class="icon-list">
              <el-tooltip content="开始" placement="top">
                <svg-icon
                  iconClass="start"
                  className="batch-icon"
                  @click="editStatus('ENABLED')"
                ></svg-icon>
              </el-tooltip>
              <el-tooltip content="暂停" placement="top">
                <svg-icon
                  iconClass="stop"
                  className="batch-icon"
                  @click="editStatus('PAUSED')"
                ></svg-icon>
              </el-tooltip>
              <span class="close-icon">
                <svg-icon
                  iconClass="close"
                  className="close-btn"
                  @click="showPlBox = false"
                ></svg-icon>
              </span>
            </div>
          </span>
        </div>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :platType="5"
          :type="3"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-download"
          style="margin-left: 16px"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          row-key="adGroupId"
          @selection-change="handleSelectionChange"
          :data="tableList"
          :max-height="tableMaxHeight"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" reserve-selection> </el-table-column>
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="true"
          >
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              width="200"
              :key="item.value"
            >
              <template slot-scope="scope">
                <div v-if="item.value === 'adGroupName'">
                  <span class="name-link" @click="checkPlan(scope.row)">{{
                    scope.row.adGroupName
                  }}</span>
                </div>
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              :width="item.width"
              :key="item.value"
            >
              <template slot-scope="scope">
                <span v-if="item.value === 'status'">{{
                  adSeriesStatusOptions.find((child) => child.value === scope.row.status).label
                }}</span>
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="80">
            <template slot-scope="scope">
              <el-switch
                :disabled="['UNSPECIFIED', 'UNKNOWN', 'REMOVED'].includes(scope.row.status)"
                v-model="scope.row.displayStatus"
                @change="(value) => changeSingleType(scope.row)"
              >
              </el-switch>
              <!-- <el-button style="margin-left: 6px" type="text">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
import SelectField from "@/components/selectField.vue";
import {
  getCommonProductList,
  getAdCampaignList,
  getGoogleAdgroupReport,
  getAdCommonAdGroupList,
  updateGoogleAdGroupStatus,
} from "@/api/promotion-google.js";
import {
  attribute,
  baseData,
  appData,
  transformEventData,
  adSeriesStatusOptions,
} from "@/config/fieldData_google";
import { getUserInfoList } from "@/api/api.js";
import { getAdCountList } from "@/api/promotion-gdt.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import moment from "moment";
import { formatTableList } from "../formatData.js";
export default {
  name: "PlanTable",
  components: {
    SvgIcon,
    SelectField,
  },
  data() {
    return {
      adSeriesStatusOptions,
      loading: false,
      promotionList: [],
      copyPromotionList: [],
      adSeriesList: [],
      copyAdSeriesList: [],
      appList: [],
      optimizerList: [],
      advertiserIdList: [],
      filterData: {
        promotionIds: [],
        advertiserIds: [],
        pkgs: [],
        projectIds: [],
        userIds: [],
        status: "",
        time: [
          moment().subtract(7, "days").format("YYYY-MM-DD"),
          moment().subtract(1, "days").format("YYYY-MM-DD"),
        ],
        search: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.adGroup },
        { title: "基础数据", list: baseData },
        { title: "APP数据", list: appData.adGroup },
        { title: "转化事件", list: transformEventData },
      ],
      staticOptions: [
        { label: "广告组ID", value: "adGroupId", width: "200" },
        { label: "广告组名称", value: "adGroupName", width: "200" },
      ],
      tableList: [],
      tableCols: [],
      showPlBox: false,
      tableMaxHeight: window.innerHeight - 345,
      checkedList: [],
      downloadLoading: false,
      totalColumn: {},
      totalReportInfo: [],
    };
  },
  mounted() {
    this.initSelectOptions();
  },
  computed: {
    ...mapState({
      isAdmin: (state) => state.login.isAdmin,
    }),
  },
  watch: {
    totalReportInfo: {
      handler(value) {
        let totalData = {};
        if (value?.length > 0) {
          totalData = value[0];
        }
        totalData.adGroupId = "合计";
        totalData.adGroupName = `总共${this.pageData.total || 0}条数据`;
        totalData.status = "--";
        totalData.budget = "--";
        this.totalColumn = totalData;
      },
      immediate: true,
    },
  },
  methods: {
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },
    initSelectOptions() {
      getCommonProductList({ platType: 5 }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getUserInfoList({
        orgIds: 254,
      }).then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.data;
        }
      });
      getAdCountList({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
      getAdCampaignList({
        pageSize: 9999,
        page: 1,
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.adSeriesList = res.data.list;
          this.copyAdSeriesList = res.data.list;
        }
      });
      getAdCommonAdGroupList({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.promotionList = res.data;
          this.copyPromotionList = res.data;
        }
      });
      this.searchGropuList();
    },
    //根据账号查询广告组
    searchGropuList() {
      let parmas = {};
      if (this.filterData.advertiserIds.length > 0) {
        parmas.advertiserIds = this.filterData.advertiserIds.join();
      }
    },
    filterPromotion(value) {
      this.promotionList = this.copyPromotionList.filter((item) => {
        let valueStr = String(value);
        return (
          item.id.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.name.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },
    filterAdSeries(value) {
      this.adSeriesList = this.copyAdSeriesList.filter((item) => {
        let valueStr = String(value);
        return (
          item.campaignId.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.campaignName.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },
    clickSearch(filterData) {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData(filterData);
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startDate: this.filterData.time[0],
        endDate: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        parmas[key] = checkData;
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        item.displayStatus = item.status === "ENABLED" ? true : false;
        item.campaignType = item.campaignType === "APP_CAMPAIGN" ? "应用安装" : "未指定";
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData(filterData) {
      if (filterData) {
        //条件查询
        this.filterData.pkgs = [];
        this.filterData.userIds = [];
        this.filterData.status = "";
        this.filterData.advertiserIds = filterData.advertiserId ? [filterData.advertiserId] : [];
        this.filterData.projectIds = filterData.campaignId ? [filterData.campaignId] : [];
        this.filterData.promotionIds = filterData.adGroupId ? [filterData.adGroupId] : [];
        this.filterData.time = filterData.time;
        this.filterData.search = "";
      }
      let parmas = this.formatData();
      this.loading = true;
      getGoogleAdgroupReport(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data.pageInfo?.list || []);
          if (this.pageData.page === 1) {
            const data = JSON.parse(
              JSON.stringify(res.data.totalReportInfo ? [res.data.totalReportInfo] : [])
            );
            this.totalReportInfo = this.formatTableData(data);
          }
          this.pageData.total = res.data.pageInfo?.total || 0;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "appName",
          "campaignName",
          "campaignId",
          "cost",
          "showCnt",
          "clickCnt",
          "ctr",
          "cpc",
          "thousandDisplayPrice",
          "convertCnt",
          "convertCntCost",
          "convertCntRate",
        ];
      }
      let allFieldsMap = attribute.adGroup.concat(baseData, appData.adGroup, transformEventData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      getGoogleAdgroupReport(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.pageInfo?.list || []);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "广告.xlsx", HeaderData);
        }
      });
    },
    //批量修改状态
    editStatus(status) {
      if (this.checkedList.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
      } else {
        let params = [];
        this.checkedList.map((item) => {
          params.push({
            advertiserId: item.advertiserId,
            bizId: item.adGroupId,
            optStatus: status,
          });
        });
        this.commitChange(params);
      }
    },
    changeSingleType(item) {
      let params = [
        {
          advertiserId: item.advertiserId,
          bizId: item.adGroupId,
          optStatus: item.displayStatus ? "ENABLED" : "PAUSED",
        },
      ];
      this.commitChange(params);
    },
    commitChange(data) {
      this.loading = true;
      updateGoogleAdGroupStatus(data).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
          this.loading = false;
          this.changePage(1);
        }
      });
    },
    checkPlan(rowData) {
      this.$emit("checkTable", {
        name: "MaterialResources",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.plan-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .multiple-select {
      width: 260px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .mult-wrap {
        display: flex;
        align-items: center;
        margin-right: auto;
      }
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .name-link {
        color: #1890ff;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #0285ff;
        }
      }
    }
  }
}
.piliang {
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 40px;
    cursor: pointer;
  }
}
</style>
